import { CatSelectIcon, DogSelectIcon, FemaleIcon, MaleIcon, OtherSelectIcon } from "../../../components/Icons";

import { IOptionGeneric } from "../../interface";
import React from "react";

export const getSpeciesWithIcons = (species: IOptionGeneric[]) => {
  return species.map((specie) => ({
    value: specie.value,
    label: <>
      <div style={{ padding: "8px 0" }}>
        {specie.label === "Dog" ? <DogSelectIcon /> : (
          specie.label === "Cat" ? <CatSelectIcon /> : <OtherSelectIcon />
        )}
      </div>
      <div style={{ paddingBottom: "6px" }}>
        {specie.label}
      </div>
    </>,
  }));
};

export const getGendersWithIcons = (genders: IOptionGeneric[]) => {
  return genders.map((gender) => ({
    value: gender.value,
    label: <>
      <div style={{ padding: "8px 0" }}>
        {gender.value === "1" ? <MaleIcon /> : null }
        {gender.value === "3" ? <FemaleIcon /> : null }
      </div>
      <div style={{ paddingBottom: "6px" }}>
        {gender.label}
      </div>
    </>,
  }));
};
